import PropTypes from 'prop-types'
import React, {useEffect} from "react"
import { salesDeveloperPrefix } from "configs/routePrefix";
import AuthService from 'services/SalesDeveloper/AuthService';

const Logout = props => {
    useEffect(() => {
        AuthService.logout()
        props.history.push(`${salesDeveloperPrefix}/login`) ;
        // props.logoutUser(props.history)
    })

    return <></>
}

Logout.propTypes = {
    history: PropTypes.object,
    logoutUser: PropTypes.func
}

// export default withRouter(connect(null, { logoutUser })(Logout))
export default Logout
